export default __webpack_public_path__ + "static/logo-fa1b80548a3f45c49ea3516c78825d62.png";